module.exports = __webpack_public_path__ + "img/113026.312e0d19.png";